import script from "./TextAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./TextAlert.vue?vue&type=script&setup=true&lang=js"

import "./TextAlert.vue?vue&type=style&index=0&id=db02dda2&lang=css"

const __exports__ = script;

export default __exports__